// extracted by mini-css-extract-plugin
export var button_container = "RelatedServices-module--button_container--lNki2";
export var page404Title = "RelatedServices-module--page404-title---S8ua";
export var related_service = "RelatedServices-module--related_service--ANrdL";
export var related_services = "RelatedServices-module--related_services--REvKA";
export var related_services_container = "RelatedServices-module--related_services_container--oZPuz";
export var seeAllButton = "RelatedServices-module--seeAllButton--Praom";